/** Marcas que dejan las extensiones de traducción conocidas. */
const TRANSLATE_MARKERS = [
  "font[_msttexthash]", // Microsoft Translator
  "font[_mstmutation]", // Microsoft Translator
  ".translated-ltr", // Google Translate (clase en <html>)
  ".translated-rtl", // Google Translate (clase en <html>)
  "#goog-gt-tt", // Google Translate (tooltip inyectado)
] as const;

/** `true` traducido, `false` limpio, `null` si el detector falló. */
export function isTranslated(): boolean | null {
  try {
    const html = document.documentElement;

    if (TRANSLATE_MARKERS.some((sel) => document.querySelector(sel))) {
      return true;
    }

    // Google reescribe lang cuando traduce. index.html declara "es".
    if (html.lang && html.lang !== "es") return true;

    return false;
  } catch {
    return null;
  }
}

export function translationContext() {
  return {
    translated: isTranslated(),
    htmlLang: document.documentElement.lang || "",
    htmlClass: document.documentElement.className || "",
  };
}
